import $ from 'jquery';
import debug from 'bows';

let log = debug('ajax');

/**
 * Standardized AJAX request which provides a special header for the theme
 *
 * @link http://api.jquery.com/jQuery.ajax/
 *
 * @param object args Args matching jQuery.ajax
 * @param function fallback (optional) Function used in case of error
 * @return jqXHR (with Deferred behavior)
 */
export const ajaxRequest = function( args, fallback ) {
	// Ensure args is an object
	if ( ! args || typeof args !== 'object' ) {
		args = {};
	}

	// Set fallback (in case something goes wrong)
	if ( ! fallback || typeof fallback !== 'function' ) {
		// noop
		fallback = () => {};
	}

	// Set defaults
	if ( ! args.url ) {
		log('Invalid request, missing URL');
		fallback();
		return;
	}
	if ( ! args.type ) {
		args.type = 'GET';
	}
	if ( ! args.beforeSend ) {
		args.beforeSend = ( xhr ) => {
			if ( typeof xhr.setRequestHeader === 'function' ) {
				xhr.setRequestHeader('X-AJAX', '1');
			} else { // Old IE
				fallback();
				return false;
			}
		};
	}
	// Add AJAX parameter to query string (acts like X-AJAX header)
	args.data = $.extend(args.data, { 'AJAX': 1 });

	log('Sending AJAX Request: ' + args.type + ' ' + args.url);
	let jqXHR = $.ajax( args );

	// Attach fallback on failure
	jqXHR.fail( ( jqXHR, textStatus, errorThrown ) => {
		// Only call fallback if completed (ignore aborted or incomplete requests)
		if ( jqXHR.readyState === 4 ) {
			fallback( jqXHR, textStatus, errorThrown );
		}
	} );

	return jqXHR;
}
